import React from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import TrueImpactButton from 'shared/design-system/components/TrueImpactButton';
import { Investment } from '../api';
import { useHistory } from 'react-router-dom';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';

interface NoAllocationsProps {
  donation: Investment;
}

const StyledDiv = styled.div`
  .allocation-button {
    margin-left: auto;
    margin-right: auto;
    margin-top: ${SPACERS.large};
  }
`;

const NoAllocations: React.FC<NoAllocationsProps> = ({ donation }) => {
  const { push } = useHistory();
  const handleClick = () => {
    const taskId = donation.allocations?.[0]?.tasks[0].taskId;
    taskId && push(`/npo/todo/by-due-date#/task/${taskId}`);
  };
  return (
    <StyledDiv>
      <TrueImpactText variant="heading">
        This donation hasn’t been allocated to a program yet.
      </TrueImpactText>
      <TrueImpactText>Would you like to do that now?</TrueImpactText>
      <TrueImpactButton className="allocation-button" onClick={handleClick}>
        Allocate this donation
      </TrueImpactButton>
    </StyledDiv>
  );
};

export default NoAllocations;
